import React from "react";
import { Container, Button, Row, Col } from "react-bootstrap";
import { LuSearchX } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
    const navigate = useNavigate();
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, rgba(240,240,240,1) 0%, rgba(255,255,255,1) 100%)",
      }}
    >
      <Row className="text-center">
        <Col>
          <div
            style={{
              padding: "40px 20px",
              maxWidth: "650px",
              margin: "0 auto",
            }}
          >
            <LuSearchX size={70} color="#b02a30" />

            <h1
              className="mt-4"
              style={{
                fontWeight: 800,
                letterSpacing: "1px",
              }}
            >
              We Couldn't Find That
            </h1>

            <p
              className="text-muted mt-3"
              style={{
                fontSize: "1.1rem",
                lineHeight: 1.7,
                maxWidth: "520px",
                margin: "0 auto",
              }}
            >
              We couldn’t find the page you’re looking for. It might have been moved or deleted.
            </p>

            <Button
              variant="danger"
              size="sm"
              onClick={()=>navigate("/")}
              className="mt-4 px-4"
              style={{
                borderRadius: "8px",
              }}
            >
              Return Home
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFoundPage;
